import { modelState } from '@/utils/modelState';
import { QueryBuilder } from './QueryBuilder';
import { v4 as uuidv4 } from 'uuid';

export namespace NeverCondition {

    export const registryEntry: QueryBuilder.ConditionRegistryEntry = {
        key: "Never",
        name: "Never",
        isCondition: isNeverCondition,
        create: createNeverCondition,
        hydrate: () => { },
        serialize: serializeNeverCondition,
        deserialize: deserializeNeverCondition,
        renderComponent: () => null
    };

    export const NeverCondition = Symbol("NeverCondition");
    export interface NeverCondition extends QueryBuilder.ConditionNodeChild {
        [NeverCondition]: boolean;
    }

    export function isNeverCondition(condition?: QueryBuilder.ConditionNodeChild): condition is NeverCondition {
        if (!condition) {
            return false;
        }

        return (condition as NeverCondition)[NeverCondition] === true;
    }

    export function createNeverCondition(skipHydration: boolean = false): NeverCondition {

        const condition: NeverCondition = {
            [QueryBuilder.Node]: true,
            [QueryBuilder.ConditionNodeChild]: true,
            [NeverCondition]: true,
            id: uuidv4(),
            version: modelState(0),
            dispose: () => { }
        };

        return condition;
    }

    function serializeNeverCondition(condition: NeverCondition): QueryBuilder.ConditionChildNodeDtoWrapper {
        const neverDto: NeverConditionDto = {
            NodeId: condition.id
        };

        return {
            Type: "Never",
            Value: neverDto
        };
    }

    interface NeverConditionDto extends QueryBuilder.NodeDto {
        //
    }

    function deserializeNeverCondition(never: NeverConditionDto): NeverCondition {
        const condition = createNeverCondition(true);
        return condition;
    }
}